import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { SecHeadAgendaService } from 'src/app/excucomm/service/sec-head-agenda.service';
import { HelperService } from 'src/app/common-service/helper.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { encryptionService } from 'src/app/common-service/cedService';
import { ExcutiveService } from 'src/app/excucomm/service/excutive.service'; 
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { SignupService } from 'src/app/common-service/signup.service';

@Component({
  selector: 'app-agenda-view',
  templateUrl: './agenda-view.component.html',
  styleUrls: ['./agenda-view.component.css']
})
export class AgendaViewComponent implements OnInit {
  agendaDetails: any;
  agendaProcessHistoryList: any = [];
  CommentsPlusMinusFlag: boolean = true;
  roleName: any;
  agendaId: any;
  decryptAgendaId: any;
  subscribe: Subject<any> = new Subject<any>();

  constructor(public route: ActivatedRoute, private spinner: NgxSpinnerService, public helper: HelperService, public tostar: ToastrService, public router: Router, public secEcService: SecHeadAgendaService,
   public ecservice: ExcutiveService, public serverURL: ServerURLService, public usrMgtService: UsrmgtService,
   public ced: encryptionService, public EncrDecr: EncrDecrService, public signin: SignupService) { }

  ngOnInit(): void {
    this.roleName = sessionStorage.getItem('selectedRole-usec');
    
    this.route.params.subscribe((params: Params) => this.decryptAgendaId = params.agendaId);
    this.agendaId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptAgendaId);

    if (this.agendaId != null) {
      this.getAgendaDetailsById(this.agendaId);
    }

    if(this.roleName === 'AFSecInCharge' || this.roleName === 'AdmsnIncharge' || this.roleName === 'AcademicIncharge' 
    || this.roleName === 'LegalSecInCharge' || this.roleName === 'AEIncharge' || this.roleName === 'ISecInCharge' 
    || this.roleName === 'RTISecInCharge' || this.roleName === 'ServerSecInCharge' || this.roleName === 'ARPMSecInCharge' 
    || this.roleName === 'PDMSSecInCharge' || this.roleName === 'InspAsstSecty' || this.roleName === 'MSAsstSecty' 
    || this.roleName === 'ARPMAsstSecty' || this.roleName === 'AcademicAsstSecty' || this.roleName === 'AdmsnAsstSecty' || this.roleName === 'PDMSAsstSecty' 
    || this.roleName === 'AEAssistantSecretary' || this.roleName === 'PDMSSectionOfficer' || this.roleName === 'LegalSectionOfficer' || this.roleName === 'RTISectionOfficer' 
    || this.roleName === 'AFSectionOfficer' || this.roleName === 'AESectionofficer' || this.roleName === 'AcademicSectionOfficer' || this.roleName === 'AdmsnSectionOfficer'
    || this.roleName === 'RTIAssistantSectionOfficer'|| this.roleName === 'ARPMAssistantSectionOfficer' || this.roleName === 'AdmsnAssistantSectionOfficer'
    || this.roleName === 'AcademicAssistantSectionOfficer' || this.roleName === 'PDMSAssistantSectionOfficer' || this.roleName === 'AFAssistantSectionOfficer' 
    || this.roleName === 'AEAssistantSectionOfficer' || this.roleName === 'LegalAssistantSectionOfficer' || this.roleName === 'LegalRetainer' || this.roleName === 'RTILegalRetainer' 
    || this.roleName === 'Accountant' || this.roleName === 'DAK_Section_Executive' || this.roleName === 'Student Admission Executive' || this.roleName === 'AcademicExecutive' 
    || this.roleName === 'ServerSecExecutive' || this.roleName === 'PDMSExecutive' || this.roleName === 'RTIExecutive' || this.roleName === 'AdmsnSecExecutive' 
    || this.roleName === 'AFExecutive' || this.roleName === 'LegalExecutive' || this.roleName === 'AEExecutive' || this.roleName === 'ARPMSecExecutive' || this.roleName === 'System Admin') {
      this.agendaProHisList();
  } else {      
      this.signin.deleteOauthToken().subscribe((result: any) => {      
    });
  }

  }

  getAgendaDetailsById(AgendaId) {
    this.spinner.show();
    this.ecservice.getECAgendaViewDetailsById(AgendaId).pipe(takeUntil(this.subscribe)).subscribe((data: any) => {
      this.spinner.hide();
      if (data != null) {
        this.agendaDetails = data;
      }
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  //added by gokul for agenda view comments
  agendaProHisList() {
    this.spinner.show();
    this.secEcService.agendaProcessHistory(Number(this.agendaId)).pipe(takeUntil(this.subscribe)).subscribe((data: any) => {
      this.spinner.hide();
      this.agendaProcessHistoryList = data;
    }, error => {
      this.spinner.hide();
      console.log(error);
      this.helper.errorMessage(error);
    });
  }

  commentsPlusMinusMethod(data: any) {
    if (data == 'plus') {
      this.CommentsPlusMinusFlag = false;
    } else if (data == 'minus') {
      this.CommentsPlusMinusFlag = true;
    }
  }

  back() {
    this.router.navigate(['/main/internal/excu/sectionHead/secExeAgendaDashBoard']);
  }

  viewDocuments(filePath: any, fileName: any) {
    this.usrMgtService.getRandomKeyGeneratorForViewDocument().subscribe((data: any) => {
      const randomkeyKey = this.ced.decryptAesformString(data.randamKey, this.serverURL.secretKey);
      this.viewDocumentsAfterEncryptedfilePath(this.ced.encryptAesToString(filePath, randomkeyKey).toString(), fileName);
    }, error => {
      console.log(error);
    });
  }

  viewDocumentsAfterEncryptedfilePath(filePath: any, fileName: any) {
    this.spinner.show();
    this.usrMgtService.ViewDocument(filePath).pipe().subscribe((result: any) => {
      this.spinner.hide();
      var blob = result;
      var fileURL = URL.createObjectURL(blob);
      if (fileName.split('.').pop().toLowerCase() === 'pdf') {
        window.open(fileURL);
      } else {
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = '_blank';
        a.download = fileName;
        a.click();
      }
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }
}
